<template lang="html">
  <div>
    <v-row class="justify-center my-4">
      <v-col cols="3" sm="2" md="1" class="text-center">
        <img src="concorde-logo-new-white.png" />
      </v-col>
    </v-row>

    <v-row class="justify-center mt-5">
      <v-col cols="12" md="7">
        <p class="white--text">
          Enter your email address that you signed up with and we'll send you a link to reset your password.
        </p>
      </v-col>
      <v-col cols="12" md="7" class="text-center">
        <v-text-field v-model="email" solo name="email" label="Email Address" @keyup.enter="resetPass" />
      </v-col>
      <v-col cols="12" md="7" class="text-center">
        <v-btn
          :dark="!!countDown"
          :disabled="!!countDown"
          :loading="loading"
          block
          large
          color="primary"
          @click.stop="resetPass()"
        >
          {{ countDown ? `Resend the email in ${countDown} seconds` : 'Send me a reset link' }}
        </v-btn>
      </v-col>
      <v-col cols="12" class="text-center">
        <p class="mt-5 white--text">
          <nuxt-link class="mt-5 white--text" to="/sign-up">
            Create an account
          </nuxt-link>
        </p>
      </v-col>
      <v-col cols="12" class="text-center">
        <p class="mt-2 white--text">
          <nuxt-link class="mt-5 white--text" to="/log-in">
            Log in
          </nuxt-link>
        </p>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data: () => ({
    loading: false,
    email: null,
    countDown: 0,
    timeout: null
  }),
  watch: {
    email(v, o) {
      if (this.countDown && v !== o) {
        clearTimeout(this.timeout)
        this.countDown = 0
      }
    },
    countDown(v) {
      if (v) {
        this.timeout = setTimeout(() => {
          this.countDown = v - 1
        }, 1000)
      }
    }
  },
  methods: {
    async resetPass() {
      try {
        let { countDown, email } = this
        if (countDown) {
          return this.$snack.info('Please wait for at least one minute for the email to land in your inbox.')
        }
        if (!email) {
          return this.$snack.info('Please enter your email address')
        }
        // format the email
        email = email.toLowerCase().trim()
        this.loading = true
        await this.$axios.post('/api/auth/reset-password-link', {
          email: email
        })
        this.$snack.info(`An email was sent to ${email} with a link to reset your password.`)
        this.countDown = 60
        this.loading = false
      } catch (e) {
        this.loading = false
        this.$handleError(e)
      }
    }
  }
}
</script>

<style lang="css"></style>
